module.exports = __webpack_public_path__ + "static/media/announcements.67fd03d0.svg";